import React from "react";
import { mapRogoDevTypeToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetRogoDebTypeColumns from "./ColumnDefinition/RogoDebTypeColumn/GetRogoDebTypeColumns";

const RogoDevTypeTable = ({
  data,
  handleOpenPopup,
  handleDelete,
  onDragEnd,
  status,
}) => {
  const columns = GetRogoDebTypeColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable
      columns={columns}
      data={mapData(data)}
      maxHeight={500}
      onDragEnd={onDragEnd}
    />
  );
};

export default RogoDevTypeTable;
